'use strict'
import request from '@/utils/request'
import qs from 'qs'

const model = {
  // 最近编辑过的项目
  currently (offset, count) {
    return request({
      url: '/project/currently',
      method: 'get',
      params: {offset, count}
    })
  },
  get (id) {
    return request({
      url: '/project/get/' + id,
      method: 'get'
    })
  },
  search (orderId) {
    return request({
      url: '/project/search',
      method: 'get',
      params: {orderId}
    })
  },
  create (orderId) {
    return request({
      url: '/project/create',
      method: 'post',
      data: qs.stringify({orderId})
    })
  },
  save (id, info, content) {
    return request({
      url: '/project/save/' + id,
      method: 'post',
      data: {info, content}
    })
  },
  close (id) {
    return request({
      url: '/project/close/' + id,
      method: 'get'
    })
  },
  apply (id, info, content) {
    return request({
      url: '/project/apply/' + id,
      method: 'post',
      data: {info, content},
      timeout: 300000
    })
  },
  keepalive (id) {
    return request({
      url: '/project/keepalive/' + id,
      method: 'post'
    })
  },
  preview (params) {
    return request({
      url: '/project/preview',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },
  histories (id) {
    return request({
      url: '/project/histories/' + id,
      method: 'get'
    })
  },
  revertVersion (projectId, hisId) {
    return request({
      url: '/project/revertVersion',
      method: 'post',
      data: qs.stringify({projectId, hisId})
    })
  }
}

export default model



// WEBPACK FOOTER //
// ./src/api/project.js